import React from 'react';
import { ReceiptLine } from 'src/components/enterprise/features/OrderHistory/OrderReceipt/ReceiptLine';

export interface IChargeProps {
  name: string;
  amount: string;
  explanation?: React.ComponentType;
  newAmount?: string;
}

export function Charges({ value }: { value: IChargeProps[] }): JSX.Element {
  return (
    <>
      {value.map(({ name, amount, explanation, newAmount }) => (
        <ReceiptLine
          key={name}
          name={name}
          value={amount}
          newValue={newAmount}
          explanation={explanation}
        />
      ))}
    </>
  );
}
